<template>
    <div class="bg-white pt-6 shadow sm:rounded-md sm:overflow-hidden">
        <div class="px-4 sm:px-6">
            <h2 class="text-lg leading-6 font-medium text-gray-900">Contract Fulfillments Summary</h2>
        </div>
        <div class="mt-6 flex flex-col">
            <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                    <div class="overflow-hidden border-t border-gray-200">
                        <table class="min-w-full divide-y divide-gray-200">
                            <thead class="bg-gray-50">
                            <tr>
                                <th class="text-left px-6 py-4 whitespace-nowrap text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Number
                                </th>
                                <th class="text-left px-6 py-4 whitespace-nowrap text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Date
                                </th>
                                <th class="text-right px-6 py-4 whitespace-nowrap text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Qty Summary (lbs)
                                </th>
                                <th class="text-right px-6 py-4 whitespace-nowrap text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Extension Summary
                                </th>
                            </tr>
                            </thead>
                            <tbody class="bg-white divide-y divide-gray-200">
                                <tr v-for="contract in contracts" :key="contract.contract_number">
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-mono">
                                        <inertia-link class="text-blue-800" :href="route('contract-details', contract.contract_number)">{{ contract.contract_number }}</inertia-link>
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-mono">
                                        {{ contract.creation_date | niceDate }}
                                    </td>

                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-mono text-right">
                                        {{ (contract.total_tons * 2000) | numberInThousands }}
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-mono text-right">
                                        ${{ contract.total | currency }}
                                    </td>
                                </tr>
                                <tr v-if="contracts.length > 1">
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-mono font-semibold">
                                        TOTALS:
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-mono">

                                    </td>

                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-mono text-right">
                                        {{ grossWeightTotal | numberInThousands }}
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-mono text-right">
                                        ${{ contractTotal | currency }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        contracts: {
            type: Array,
            required: true,
            defualt: []
        }
    },
    computed: {
        grossWeightTotal() {
            return this.contracts.reduce(function(prev, cur) {
                return Number(prev) + Number(cur.total_tons);
            }, 0) * 2000
        },
        contractTotal() {
            return this.contracts.reduce(function(prev, cur) {
                return Number(prev) + Number(cur.total);
            }, 0)
        }
    }
}
</script>
